
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getCompanyPricingPageUrl } from "@/utils/metricsHelper";
import { createSafeExternalUrl } from "@/utils/urlUtils";

interface PricingPageLinkProps {
  slug: string;
}

export const PricingPageLink = ({ slug }: PricingPageLinkProps) => {
  const pricingPageUrl = getCompanyPricingPageUrl(slug);
  
  if (!pricingPageUrl) {
    return null;
  }
  
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => {
        // Log the URL being opened
        console.log('🔗 [PricingPageLink] Opening pricing page URL:', pricingPageUrl);
        // Use the safe URL (getCompanyPricingPageUrl already uses createSafeExternalUrl)
        window.open(pricingPageUrl, '_blank', 'noopener,noreferrer');
      }}
      className="flex items-center gap-1"
    >
      <ExternalLink className="h-4 w-4" />
      View Pricing Page
    </Button>
  );
};
